import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const WorkflowBuilderPage = lazy(() =>
  import('../pages/workflow-builder/WorkflowBuilderPage').then((m) => ({ default: m.WorkflowBuilderPage })),
)

export const workflowBuilderRoutes: RouteObject[] = [
  { path: '/workflow-builder', element: <WorkflowBuilderPage /> },
  { path: '/workflow-builder/new', element: <WorkflowBuilderPage /> },
  { path: '/workflow-builder/:id', element: <WorkflowBuilderPage /> },
]
